import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reduxPromise from 'redux-promise';
import App from './App';
import { reducer } from './utils/redux/reducers';

/**
 * Declare store
 */
const store = createStore(reducer, applyMiddleware(reduxPromise));

/**
 * Render App
 */
ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</Provider>,
	document.getElementById('root')
);
